import { Navigator }   from "../../main_components/navigator";
import Styles          from "./view_product.module.css";
import { ProHeadline } from "../../subcomponents/subcomponents";
import { Product }     from "./view_product_components";
import testimg         from "../../images/11905945_4857949.jpg";
export const ViewProductBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const product = {
        image: testimg,
        imageTheme: "#ffc107",
        link: "/view_list",
        productName: "Product Name",
        productTheme: "#607d8b",
        rate: <><i style={{ margin: "0 5px" }} className="bi bi-star-fill"></i><i style={{ margin: "0 5px" }} className="bi bi-star-fill"></i><i style={{ margin: "0 5px" }} className="bi bi-star-fill"></i><i style={{ margin: "0 5px" }} className="bi bi-star-half"></i><i style={{ margin: "0 5px" }} className="bi bi-star"></i></>,
        rateTheme: "#ffc107",
        teamTitle : "Product Member",
        teamTitleIcon: <i className="bi bi-people-fill"></i>,
        teamSection: [
            { icon: <i className="bi bi-person-vcard-fill"></i>, name: "Paradox", theme: "#455a64", link: null },
            { icon: <i className="bi bi-person-vcard-fill"></i>, name: "Oryan Pax", theme: "#455a64", link: null }
        ],
        date: "2024/10/16",
        sections: [
            { code: "const love = true;", codeTheme: "#8d6e63", title: "Paradox", text: "The oldest classical British and Latin writings had little or no space between words and could be written in boustrophedon (alternating directions). Over time, text direction (left to right) became standardized. Word dividers and terminal punctuation became common. The first way to divide sentences into groups was the original paragraphos, similar to an underscore at the beginning of the new group.[1] The Greek parágraphos evolved into the pilcrow (¶), which in English manuscripts in the Middle Ages can be seen inserted inline between sentences." },
        ],
        sectionsTheme: "gray",
        sectionsColor: "lightgray",
    };
    const headlines = [
        "Unleash Innovation: Discover Our Cutting-Edge Product Line!",
        "Transform Your Experience: Explore Our Unique Offerings!",
        "Revolutionize Your Routine: Dive into Our Exceptional Products!",
        "Elevate Your Lifestyle: Discover What Our Products Can Do for You!",
        "Experience Quality: Explore Our Premium Product Selection!",
        "Your Next Favorite Thing Awaits: Check Out Our Product Range!",
        "Unlock Possibilities: Discover the Benefits of Our Products!",
        "Find Your Perfect Match: Explore Our Diverse Product Categories!",
        "From Everyday Essentials to Luxuries: Discover Our Product Collection!",
        "Join the Movement: Explore How Our Products Can Enhance Your Life!"
    ];
    return (
        <main className={ Body }>
            <Navigator page={ "Products" }/>
            <main className={ Content }>
                <ProHeadline headlines = { headlines }/>
                <Product     product   = { product   }/>
            </main>
        </main>
    );
};
